export const quickTimer = (duration: number) =>
  new Promise<number>((resolve) => setTimeout(resolve, duration));
